import React, { FC, ReactNode } from 'react'
import cx from 'classnames'

import * as SC from './styled'

export type FormLabelProps = React.LabelHTMLAttributes<HTMLLabelElement> & {
  className?: string
  required?: boolean
  error?: boolean
  children?: ReactNode
}

const FormLabel: FC<FormLabelProps> = ({
  error,
  children,
  className,
  required,
  ...props
}) => {
  return (
    <SC.Label
      {...props}
      $required={required}
      $error={error}
      className={cx('FormLabel', className)}
    >
      {children}
    </SC.Label>
  )
}

export default FormLabel
